function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_1",
  "data-name": "Camada 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_416",
  "data-name": "Pfad 416",
  d: "M4.026,970.549.809,967.04,0,967.781l4.026,4.391,4.026-4.391-.809-.742Z",
  transform: "translate(0 -960.673)",
  fill: "#111"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_417",
  "data-name": "Pfad 417",
  d: "M4.026,1.624l3.217,3.51.809-.742L4.026,0,0,4.392l.809.742Z",
  fill: "#111"
}));

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sort",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.052,
    height: 11.5,
    viewBox: "0 0 8.052 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.4fbb34d3.svg";
export { ForwardRef as ReactComponent };